import { NextPage } from "next";
import { GetServerSideProps } from 'next';
import blogService from '@/lib/services/blogService'
import { IDiWidget, IHomeData, IMetaHead, IPageMenu, IRelatedCat } from "@/interfaces";
import { Trendsblog } from "@/components/trends";
import { CountryCode } from "@/lib/constants";
import { MetaHead } from "@/components/shared/metaHead";
import { SchemaHead } from "@/components/shared/schemaHead";
import { BreadCrumb } from "@/components/shared/breadCrumb";
import { useEffect } from "react";
import { useGlobalContext } from "@/lib/context";
import productService from "@/lib/services/productService";

type Props = {
  trendsBlog: any
  countryCode: CountryCode
  blogCats: IHomeData[]
  filterWidget: IDiWidget
  navSchemaData:IPageMenu[]
  relatedCatPosts:IRelatedCat[]
}
const ProductBlog: NextPage<Props> = ({ trendsBlog, blogCats, filterWidget,navSchemaData,relatedCatPosts}) => {
  const {props:{countryCode,isMobileView},funs: { toggleFloatingWidget }} = useGlobalContext()
  useEffect(() => {
      isMobileView && toggleFloatingWidget(true);
  }, []);
  const blog = trendsBlog[0];  
  const baseUrl = process.env.SITE_URL
  const siteURL=process.env.SITE_URL+"/"+countryCode;
  const catSlug = trendsBlog[0].post_category.cat_url && trendsBlog[0].post_category.cat_url;
  const postSLug = trendsBlog[0].parmalink;
  const customPageUrl = `/${CountryCode.INR}/trends/${catSlug}/${postSLug}`;
 const totalWords = blog.post_content?blog.post_content.replace(new RegExp('<[^>]*>', 'g'), ' ').replace(/(\s\s\s*)/g, ' ').replace(/["]+/g, ''):'';
  const ImageSchema=()=>{
    const ImagePaths = []
    if(blog&&blog.image_Urls){
      for (let i = 0; i < blog.image_Urls.length; i++) {
        ImagePaths.push(`"${blog.image_Urls[i]}"`)
      }
    }
    return ImagePaths
  }
  const faqData=()=>{
    const faqs = []
    if(blog.Post_faq && blog.Post_faq.FAQ)
    for(const d of blog.Post_faq.FAQ){
      faqs.push(`{
          "@type":"Question",
          "name":"${d.question}",
          "acceptedAnswer":{
          "@type":"Answer",
          "text":"${d.answer.replace(new RegExp('<[^>]*>', 'g'), ' ').replace(/(\s\s\s*)/g, ' ')}"}
        }`)
    }
   return faqs }
  const schemData = [{
    __html: `
      {
        "@context": "https://schema.org",
        "@type": "Article",
        "mainEntityOfPage": {
        "@type":"WebPage",
        "@id": "${siteURL+"/trends/"+blog.parmalink}"},
        "headline": "${blog.post_title}",
        "image":[${ImageSchema()}],
        "datePublished": "${blog.post_date}",
        "dateModified":  "${blog.post_date}",
        "author": [{
            "@type": "Person",
            "name": "${blog.author_name}",
            "url":  "${siteURL+"/trends/author/"+blog.autho_slug}" 
          }],
          "publisher": [{
        "@type": "Organization",
        "name": "Interior Company",
        "url": "${baseUrl}",
        "logo": {
        "@type": "ImageObject",
        "url": "${siteURL}/assets/images/interior-logo.svg"
        }
        }],
        "articleSection":["${blog.post_category.cat_name}"],
        "inLanguage":"en-IN",
        "isFamilyFriendly": "true",
        "description": "${blog.meta_description}", 
        "articleBody": "${totalWords}"
       }`},
         {__html:`
         {
       "@context": "http://schema.org/",
       "@type":"FAQPage",
       "mainEntity" : [${faqData()}]
}
`},]
  
const metaData: IMetaHead = {
  title:blog.meta_title,
  description: blog.meta_description,
  ogImage:process.env.CMS_CDN_URL+'/'+blog.post_relative,
  hreflangNotRequired:true,
  pageGroup:"TRENDS-BLOG-PAGE"
};
  return (<>
    <MetaHead metaData={metaData} />
    <BreadCrumb customPageUrl={customPageUrl}/>
    <SchemaHead data={blog && blog.Post_faq && blog.Post_faq.FAQ && blog.Post_faq.FAQ.length > 0? schemData:[schemData[0]]} navSchemaData={navSchemaData}/>
    <Trendsblog blogData={trendsBlog} blogCats={blogCats} countryCode={CountryCode.INR} filterWidget={filterWidget}  relatedCatPosts={relatedCatPosts}/>
    {/* {blog && blog.Post_faq && blog.Post_faq.FAQ && blog.Post_faq.FAQ.length > 0 ? <TrendsLongBody faqData={blog.Post_faq} /> : null} */}

  </>)
}
export const getServerSideProps: GetServerSideProps = async (context) => {
  const blogSlug = context.params?.TrendsBlog?.toString() || '';
  const blogCats = await blogService.getCategories(CountryCode.INR);
  const trendsBlog = (await blogService.getPostBySlug(blogSlug,CountryCode.INR)) || [];
  const dicategorySlug = trendsBlog[0]?.post_category?.dislug;
  const catSlug = trendsBlog[0]?.post_category?.cat_name?.textToSlug();
  const filterWidget = dicategorySlug ? await productService.getFilterWidget(dicategorySlug,CountryCode.INR) : [];
  const relatedCatPosts = catSlug ? await blogService.relatedCatPosts(catSlug) : [];
  if (!blogSlug || blogSlug.length == 0 || !trendsBlog || blogSlug != trendsBlog[0]?.parmalink || !trendsBlog[0].parmalink)
    return { notFound: true }
  return {
    props: { trendsBlog, blogCats, filterWidget ,relatedCatPosts }
  }
}
export default ProductBlog;